/**
 * Maqueta Intuitiva - JavaScript functions
 * Version: 1.0.0
 */

// Función que se ejecuta cuando el DOM está cargado
document.addEventListener('DOMContentLoaded', function() {
  // Inicializa todos los componentes Maqueta Intuitiva
  const maquetas = document.querySelectorAll('.maqueta-intuitiva');
  maquetas.forEach(initMaquetaIntuitiva);
  
  // Observador de redimensión para actualizar layouts responsivos
  window.addEventListener('resize', debounce(function() {
    maquetas.forEach(updateMaquetaResponsive);
  }, 250));
  
  // Observador para cambios en el tema (ej. modo oscuro/claro)
  const htmlElement = document.documentElement;
  const mediaQueryList = window.matchMedia('(prefers-color-scheme: dark)');
  mediaQueryList.addEventListener('change', function() {
    maquetas.forEach(updateMaquetaIntuitiva);
  });
});

/**
 * Inicializa un componente de Maqueta Intuitiva
 * @param {HTMLElement} maqueta - El elemento contenedor de la maqueta
 */
function initMaquetaIntuitiva(maqueta) {
  // Inicializa propiedades de imagen
  const imageContainers = maqueta.querySelectorAll('.maqueta-intuitiva__image');
  imageContainers.forEach(function(container) {
    if (container.classList.contains('placeholder')) {
      // Si la imagen es un placeholder, no hay nada que hacer
      return;
    }
    
    // Asegura que las imágenes carguen correctamente
    const img = container.querySelector('img');
    if (img) {
      img.addEventListener('load', function() {
        container.classList.add('loaded');
      });
      
      // Si la imagen ya está en caché, marcarla como cargada
      if (img.complete) {
        container.classList.add('loaded');
      }
    }
  });
  
  // Inicializa videos
  const videos = maqueta.querySelectorAll('.maqueta-intuitiva__video');
  videos.forEach(function(video) {
    // Implementar cualquier lógica específica para videos si es necesario
    // Por ejemplo, botones personalizados de reproducción, etc.
  });
  
  // Actualiza estados responsive
  updateMaquetaResponsive(maqueta);
}

/**
 * Actualiza los estados responsive de la maqueta
 * @param {HTMLElement} maqueta - El elemento contenedor de la maqueta
 */
function updateMaquetaResponsive(maqueta) {
  // Implementar lógica responsiva adicional si es necesaria
  // Esto se llamará en el resize del navegador
  
  // Ejemplo: ajustar alturas iguales en las columnas si se requiere
  const rows = maqueta.querySelectorAll('.maqueta-intuitiva__row');
  rows.forEach(function(row) {
    // Solo aplicar alturas iguales en desktop/tablet, no en móvil
    if (window.innerWidth <= 749) {
      // Resetear alturas en móvil
      const columns = row.querySelectorAll('.maqueta-intuitiva__column');
      columns.forEach(function(column) {
        column.style.height = 'auto';
      });
      return;
    }
    
    // Si la fila tiene configuración de 'stretch', hacer que todas las columnas tengan la misma altura
    if (getComputedStyle(row).getPropertyValue('--mi-row-align') === 'stretch') {
      equalizeColumnHeights(row);
    }
  });
}

/**
 * Actualiza un componente de Maqueta Intuitiva
 * @param {HTMLElement} maqueta - El elemento contenedor de la maqueta
 */
function updateMaquetaIntuitiva(maqueta) {
  // Se llama cuando hay cambios en el tema o en la página
  // Implementar lógica adicional si es necesaria
}

/**
 * Hace que todas las columnas de una fila tengan la misma altura
 * @param {HTMLElement} row - El elemento de fila
 */
function equalizeColumnHeights(row) {
  const columns = row.querySelectorAll('.maqueta-intuitiva__column');
  let maxHeight = 0;
  
  // Primero, resetear alturas y medir
  columns.forEach(function(column) {
    column.style.height = 'auto';
    const height = column.offsetHeight;
    maxHeight = Math.max(maxHeight, height);
  });
  
  // Luego, aplicar la altura máxima a todas las columnas
  columns.forEach(function(column) {
    column.style.height = maxHeight + 'px';
  });
}

/**
 * Función de debounce para limitar llamadas de función frecuentes
 * @param {Function} func - La función a ejecutar
 * @param {number} wait - Tiempo de espera en milisegundos
 * @return {Function} - Función con debounce aplicado
 */
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}